<div *ngIf="!readyForAction" class="d-inline-flex m-auto align-content-center">
    <i class="fad fa-spinner-third fa-spin"></i>
</div>
<div *ngIf="readyForAction">
    <determinant-triggers-field
        [effects]="behaviour.effects"
        [componentHidden]="componentHidden"
        [componentDisabled]="componentDisabled"
        [componentName]="componentName"
        [componentActivate]="componentActivate"
        (saveOrUpdate)="saveBehaviourComponent($event)"
        (updateComponentProperty)="updateComponentProperty($event)"
        [determinantMapById]="determinantMapById">
    </determinant-triggers-field>
    <!--
    <determinant-triggers-field-content
        [showHeader]="false" class="d-none">
    </determinant-triggers-field-content>
    <determinant-triggers-action
        [showHeader]="false">
    </determinant-triggers-action>
    -->
</div>
